var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Example study")]),_c('p',{attrs:{"align":"justify"}},[_vm._v(" The following example shows what information is extracted from a typical study ")]),_c('p',[_c('curation-example-image')],1),_c('p',[_c('single-study-button')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }